import { createSlice } from "@reduxjs/toolkit";
import { STATIC_LOCATIONS } from "../../utils/staticLocations";
import { STATIC_LANGUAGES } from "../../utils/staticLanguages";

export const initialStateForUltimateDiscoverSlice = {
  platform: "instagram",
  searchKeyword: "",
  filters: {
    minFollowers: null,
    maxFollowers: null,
    minEngagement: null,
    maxEngagement: null,
    gender: "",
    locations: ["India"],
    isVerified: null,
    categories: [],
    languages: ["en"],
    brands: [],
    audienceInterests: [],
    audienceLocations: [],
    hasBrandDeals: null,
  },
  results: [],
  totalCount: 0,
  hasMore: false,
  page: 1,
  limit: 10,
  totalPages: 0,
  showLoading: false,
  searchRequestId: null,
  creditsRemaining: null,
  source: null,
  aiInfo: null,
  error: null,
  languagesList: STATIC_LANGUAGES,
  locationsList: STATIC_LOCATIONS,
  brandsList: [],
  ytTopicsList: [],
  audienceInterestsList: [],
  audienceLocationsList: [],
  audienceBrandCategoriesList: [],
  audienceBrandNamesList: [],
  credits: null,
};

export const ultimateDiscoverSlice = createSlice({
  name: "ultimateDiscover",
  initialState: initialStateForUltimateDiscoverSlice,
  reducers: {
    updateUltimateDiscover: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetUltimateDiscover: () => {
      return initialStateForUltimateDiscoverSlice;
    },
    setPlatform: (state, action) => {
      state.platform = action.payload;
    },
    setSearchKeyword: (state, action) => {
      state.searchKeyword = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = initialStateForUltimateDiscoverSlice.filters;
    },
    setResults: (state, action) => {
      state.results = action.payload.results || [];
      state.totalCount = action.payload.total || 0;
      state.hasMore = action.payload.hasMore || false;
      state.totalPages = action.payload.totalPages || 0;
      state.searchRequestId = action.payload.searchRequestId || null;
      state.creditsRemaining = action.payload.creditsRemaining || null;
      state.source = action.payload.source || null;
      state.aiInfo = action.payload.ai || null;
    },
    appendResults: (state, action) => {
      state.results = [...state.results, ...(action.payload.results || [])];
      state.totalCount = action.payload.total || state.totalCount;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLoading: (state, action) => {
      state.showLoading = action.payload;
    },
  },
});

export const {
  updateUltimateDiscover,
  resetUltimateDiscover,
  setPlatform,
  setSearchKeyword,
  setFilters,
  clearFilters,
  setResults,
  appendResults,
  setPage,
  setLoading,
} = ultimateDiscoverSlice.actions;

export default ultimateDiscoverSlice.reducer;
